import { Avatar, Box, Button, Grid, Grid2, MenuItem, Select, Tab, Tabs, Typography } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import mapPin from '../../assets/icons/LocationPin.svg';
import pickupMarker from '../../assets/icons/PickupIcon.svg';
import dropMarker from '../../assets/icons/DropIcon.svg';
import { DirectionsRenderer, GoogleMap, Marker, useJsApiLoader } from "@react-google-maps/api";
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import {makeGetRequestToUrl} from '../commonFunc.jsx';
import config from '../../config/config.js';
import { useNavigate } from "react-router-dom";
import vehicleTypeCar from '../../assets/images/vehicleTypeCar.svg';
import vehicletypeAuto from '../../assets/images/vehicletypeAuto.svg';
import vehicleTypeBike from '../../assets/images/vehicleTypeBike.svg';
import pickupIcon from '../../assets/icons/PickupIcon.svg';
import dropIcon from '../../assets/icons/DropIcon.svg';
// import constants from '../../constant.js';

const LIBRARIES = ["maps", "drawing", "places", "geometry"];
var constants = require('../../constant');

const styles = {
    errorBox: {
      backgroundColor: '#EFFBF7',
      color: '#0DBA78',
      border: '1px solid #0DBA78',
      paddingLeft: '10%',
      paddingRight: '10%',
      borderRadius: '5px',
      marginTop: '6px'
    }
};

function CustomTabPanel(props) {
    const { children, value, index, ...other } = props;
  
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
      </div>
    );
}

function a11yProps(index) {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    };
}

const MapView = () => {
    const serverUrl = config.serverUrl;
    const token = localStorage.getItem('token');
    const cities = JSON.parse(localStorage.getItem('cities'));

    const [cityFilter, setCityFilter] = useState(cities[0].city_id);
    const [statusFilter, setStatusFilter] = useState(1);

    const handleCityChange = (e) =>{
        const city =  cities.find((cityObj) => cityObj.city_id === e)
    }
    const [pickupLocation, setPickupLocation] = useState('');
    const [pickupLatLng, setPickupLatLng] = useState(null);

    const [dropLocation, setDropLocation] = useState('');
    const [dropLatLng, setDropLatLng] = useState(null);

    const inputRef = useRef(null);   //pickup
    const inputDropRef = useRef(null);

    const [mapViewData, setMapViewData] = useState([]);

    const [directions, setDirections] = useState(null);
    const [pickupAddress, setPickupAddress] = useState('');
    const [dropAddress, setDropAddress] = useState('');
    const [rideDistance, setRideDistance] = useState(0);
    const [tokenExpired, setTokenExpired] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [selectedGrid, setSelectedGrid] = useState(null);
    const [value, setValue] = React.useState(0);
    const [gridClickData, setGridClickData] = useState(null);
    const [center,setCenter] = useState(null);
    const [mapLoaded, setMapLoaded] = useState(null);

    const mapRef = useRef(null); // Reference to the Google Map instance
    const directionsRendererRef = useRef(null); // Reference to the DirectionsRenderer instance

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const navigate = useNavigate();

    const loaderOptions = {
        id: 'google-map-script',
        googleMapsApiKey: constants.API_KEY, // Replace with your actual API key
        libraries: LIBRARIES,
    }
    
    const { isLoaded, loadError } = useJsApiLoader(loaderOptions);
    const [map, setMap] = useState(null)

    const containerStyle = {
        width: '100%',
        height: '380px',
    };
    const containerStyleMain = {
        width: '100%',
        height: '550px',
    }
    

    useEffect(()=>{
        if(gridClickData){

            const pickupLat = Number(gridClickData.engagement_details?.pickup_latitude) || 0;
            const pickupLng = Number(gridClickData.engagement_details?.pickup_longitude) || 0;
            const dropLat = Number(gridClickData.engagement_details?.drop_latitude) || 0;
            const dropLng = Number(gridClickData.engagement_details?.drop_longitude) || 0;

            const center = {
                lat: (pickupLat + dropLat) / 2,
                lng: (pickupLng + dropLng) / 2,
            };
            setCenter(center);
        }
        
    }, [gridClickData])

    const centerMain = {
        lat: mapViewData && mapViewData.length > 0
            ? mapViewData.reduce((sum, point) => sum + parseFloat(point.driver_details?.driver_current_latitude || 0), 0) / mapViewData.length
            : 0,
        lng: mapViewData && mapViewData.length > 0
            ? mapViewData.reduce((sum, point) => sum + parseFloat(point.driver_details?.driver_current_longitude || 0), 0) / mapViewData.length
            : 0,
    };

    const onLoad = React.useCallback((map) => {
        console.log("Map loaded successfully");
        mapRef.current = map;
        setMapLoaded(map);
    }, []);

    const onUnmount = React.useCallback(function callback(map) {
        mapRef.current = null;
        setMapLoaded(map);
    }, []);

    // const fetchDirections = () => {
    //     if (pickupLatLng && dropLatLng) {
    //         if (directionsRendererRef.current) {
    //             directionsRendererRef.current.setMap(null);
    //             directionsRendererRef.current = null; // Clear reference
    //         }

    //         const directionsService = new window.google.maps.DirectionsService();
    //         const request = {
    //             origin: pickupLatLng,
    //             destination: dropLatLng,
    //             travelMode: window.google.maps.TravelMode.DRIVING, // or WALKING, BICYCLING, etc.
    //         };
    //         directionsService.route(request, (result, status) => {
    //             if (status === window.google.maps.DirectionsStatus.OK) {
    //                 console.log('ride distance = ', result.routes[0]);
    //                 // Initialize DirectionsRenderer if not already created
    //                 if (!directionsRendererRef.current) {
    //                     directionsRendererRef.current = new window.google.maps.DirectionsRenderer();
    //                 }

    //                 // Clear existing polyline and render new directions
    //                 directionsRendererRef.current.setMap(mapRef.current);
    //                 directionsRendererRef.current.setDirections(result);
    //                 // setDirections(result);
    //             } else {
    //                 console.error("Directions request failed due to " + status);
    //             }
    //         });
    //     }
    // };

    const fetchDirections = () => {
        if (pickupLatLng && dropLatLng) {
            if (!mapRef.current) {
                console.error("Map instance is not available.");
                return;
            }

            const bounds = new window.google.maps.LatLngBounds();
            bounds.extend(pickupLatLng);
            bounds.extend(dropLatLng);
            mapRef.current.fitBounds(bounds);

            if (mapRef.current.curvedPolyline) {
                mapRef.current.curvedPolyline.setMap(null);
            }
            // if (mapRef.current.polyline) {
            //     mapRef.current.polyline.setMap(null);
            // }
            if (mapRef.current.pickupMarker) {
                mapRef.current.pickupMarker.setMap(null);
            }
            if (mapRef.current.dropMarker) {
                mapRef.current.dropMarker.setMap(null);
            }

            const linePath = [];
            const numIntermediatePoints = 100;
            const curveFactor = 0.6; 
            const midLat = (pickupLatLng.lat + dropLatLng.lat) / 2;
            const midLng = (pickupLatLng.lng + dropLatLng.lng) / 2;
            // Apply a positive offset to latitude for an upward curve
            const deltaLat = dropLatLng.lat - pickupLatLng.lat;
            const deltaLng = dropLatLng.lng - pickupLatLng.lng;
            const curveLat = midLat - deltaLat * curveFactor;
            const curveLng = midLng + deltaLng * curveFactor;

            const curveMidpoint = new window.google.maps.LatLng(curveLat, curveLng);

            for (let i = 0; i <= numIntermediatePoints; i++) {
                const fraction = i / numIntermediatePoints;
                const firstSegment = window.google.maps.geometry.spherical.interpolate(
                    pickupLatLng,
                    curveMidpoint,
                    fraction
                );
                const secondSegment = window.google.maps.geometry.spherical.interpolate(
                    curveMidpoint,
                    dropLatLng,
                    fraction
                );
                const interpolatedPoint = window.google.maps.geometry.spherical.interpolate(
                    firstSegment,
                    secondSegment,
                    fraction
                );
                linePath.push(interpolatedPoint);
            }
            const curvedPolyline = new window.google.maps.Polyline({
                // path: [pickupLatLng, dropLatLng],
                path: linePath,
                geodesic: true,
                strokeColor: '#0065FF',
                strokeOpacity: 1.0,
                strokeWeight: 4
            });
            curvedPolyline.setMap(mapRef.current);
            mapRef.current.curvedPolyline = curvedPolyline;

            // const polyline = new window.google.maps.Polyline({
            //     path: [pickupLatLng, dropLatLng],
            //     // path: linePath,
            //     geodesic: true,
            //     strokeColor: '#0650FF',
            //     strokeOpacity: 1.0,
            //     strokeWeight: 6,
            // });
            // polyline.setMap(mapRef.current);
            // mapRef.current.polyline = polyline;

            const pickupMarker = new window.google.maps.Marker({
                position: pickupLatLng,
                map: mapRef.current,
                title: "Pickup",
                icon: {
                    url: pickupIcon, // Use your pickup icon URL
                    scaledSize: new window.google.maps.Size(30, 30),
                },
            });
            mapRef.current.pickupMarker = pickupMarker;

            const dropMarker = new window.google.maps.Marker({
                position: dropLatLng,
                map: mapRef.current,
                title: "Drop",
                icon: {
                    url: dropIcon, // Use your drop icon URL
                    scaledSize: new window.google.maps.Size(30, 30),
                },
            });
            mapRef.current.dropMarker = dropMarker;
        }
    }

    const handleGridClick = (data) => {
        // if (directionsRendererRef.current) {
        //     directionsRendererRef.current.setMap(null);
        //     directionsRendererRef.current = null;
        // }

        setSelectedGrid(data.engagement_details?.engagement_id);
        setGridClickData(data);
        setPickupLatLng({ lat: Number(data.engagement_details?.pickup_latitude), lng: Number(data.engagement_details?.pickup_longitude) });
        setDropLatLng({ lat: Number(data.engagement_details?.drop_latitude), lng: Number(data.engagement_details?.drop_longitude) });
    }

    useEffect(() => {
        if (mapLoaded && pickupLatLng && dropLatLng) {
            fetchDirections();
        }
    },[mapLoaded, dropLatLng, pickupLatLng]);

    const getOngoingRides = async() =>{
        try{
            const token = localStorage.getItem('token');
            const timestamp = new Date().getTime();
            const url = serverUrl + "/panel/fetch_city_rides";
            const obj={
                token: token,
                timestamp: timestamp,
                city_id: cityFilter,
                status: statusFilter
            }
            const response =  await makeGetRequestToUrl(url, obj);
            

            if(response.flag==102){
                console.log('Token is expired. Please login again')
                localStorage.removeItem('token');
                console.log('toke====.....==== ', token);
                setErrorMessage('Your session has expired. Please log in again.');
                setTokenExpired(true);
                setTimeout(() => {
                    navigate('/signup');
                }, 2000);
            }

            if(response.flag === 200){
                const mapViewData = response.data;
                setMapViewData(mapViewData);
            }
            else {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }
        }
        catch (error) {
            console.error('Error fetching data:', error);
        }
    }

    useEffect(() => {
        getOngoingRides();
    },[cityFilter, statusFilter]);

    const handleStatusChange = (event) => {
        setStatusFilter(event.target.value);
    };

    return(
        <div>
            <Typography style={{ fontSize: '28px', fontWeight: '500' }}>Map View</Typography>

            <Grid2 item container spacing={2} sx={{marginTop:'1%'}}>
                <Grid2 item>
                    <Select value={cityFilter} onChange={(e) => handleCityChange(e.target.value)} displayEmpty
                    style={{width: '190px',height:'50px',borderRadius:'8px',backgroundColor: cityFilter ? '#F9F9F9' : '#FFFFFF'}}>
                        <MenuItem value="">Select City</MenuItem>
                        {cities.map((city) => (
                            <MenuItem key={city.city_name} value={city.city_id}>
                                {city.city_name}
                            </MenuItem>
                        ))}
                    </Select>
                </Grid2>

                <Grid2 item>
                    <Select value={statusFilter} onChange={handleStatusChange} displayEmpty
                    style={{width: '190px',height:'50px',borderRadius:'8px',backgroundColor: statusFilter ? '#F9F9F9' : '#FFFFFF'}}>
                        {/* <MenuItem value="">Select Status</MenuItem> */}
                        <MenuItem value="1">Ongoing</MenuItem>
                        {/* {Object.entries(constants.panelengagmentStatus).map(([key, value]) => (
                            <MenuItem key={key} value={value}>
                                {key.charAt(0).toUpperCase() + key.slice(1).toLowerCase()}
                            </MenuItem>
                        ))} */}
                    </Select>
                </Grid2>
            </Grid2>

            <Grid2 item container size={12} spacing={2}>
                <Grid2 item size={4.2} sx={{ overflowY:'auto', maxHeight:'580px'}}>
                    {mapViewData &&  mapViewData.length>0 ? 
                        (mapViewData.map((marker, index) => (
                            <Grid2 item className="mainBox" sx={{marginTop:'4%',cursor: 'pointer',
                            border: selectedGrid===marker.engagement_details?.engagement_id ? "1px solid #83888E": 'none',
                            boxShadow: selectedGrid===marker.engagement_details?.engagement_id ? "2" : 'none'
                        }} 
                            key={index} onClick={() => handleGridClick(marker)}>
                                <Grid2 item container>
                                    <Grid2 item size={9}>
                                        <Typography sx={{fontSize:'12px', color:'#83888E'}}>Engagement ID </Typography>
                                        <Typography sx={{fontSize:'16px'}}>ID: {marker.engagement_details?.engagement_id}</Typography>
                                    </Grid2>
                                    <Grid2 item size={3}>
                                        <Button
                                            variant="contained"
                                            style={{
                                                backgroundColor: marker.driver_details?.driver_current_status==0 ? '#F9E9E9' : '#E7F8F2',
                                                color: marker.driver_details?.driver_current_status==0 ? '#D14545' : '#0DBA78',
                                                textTransform: 'none',
                                                pointerEvents: 'none',
                                                borderRadius: '6px',
                                                minWidth: '60px',
                                                border:'none',
                                                boxShadow: 'none',
                                                fontFamily: 'Poppins',
                                                marginRight:'16px'
                                            }}
                                        >
                                            <FiberManualRecordIcon style={{ fontSize: '14px' }}/> {marker.driver_details?.driver_current_status==0 ? 'Inactive' : 'Active'}
                                        </Button>
                                    </Grid2>
                                </Grid2>

                                <Grid2 item container sx={{padding:'2%', marginTop:'2%'}}>
                                    <Grid2 item size={1}>
                                        <img src={pickupMarker} alt="pickup marker" width="20px" height="20px" />
                                    </Grid2>
                                    <Grid2 item size={11}>
                                        <Typography sx={{fontSize:'14px'}}>{marker.engagement_details?.pickup_address}</Typography>
                                    </Grid2>
                                </Grid2>
                                <hr style={{border: 'none', borderTop: '2px dotted #D1D5DB', marginLeft:'36px'}} />

                                <Grid2 item container sx={{padding:'2%'}}>
                                    <Grid2 item size={1}>
                                        <img src={dropMarker} alt="drop marker" width="20px" height="20px" />
                                    </Grid2>
                                    <Grid2 item size={11}>
                                        <Typography sx={{fontSize:'14px'}}>{marker.engagement_details?.drop_address}</Typography>
                                    </Grid2>
                                </Grid2>
                                <hr style={{borderTop: '1px solid #D1D5DB'}} />

                                <Grid2 item container sx={{marginTop:'2%'}}>
                                    <Grid2 item size={9.6} sx={{marginTop:'1%'}}>
                                        {marker.engagement_details?.vehicle_type==1 && (
                                            <Grid2><img src={vehicleTypeCar} alt="taxi"/></Grid2>
                                        )}
                                        {marker.engagement_details?.vehicle_type==2 && (
                                            <Grid2><img src={vehicleTypeBike} alt="bike"/></Grid2>
                                        )}
                                        {marker.engagement_details?.vehicle_type==3 && (
                                            <Grid2><img src={vehicletypeAuto} alt="auto"/></Grid2>
                                        )}
                                    </Grid2>
                                    <Grid2 item size={2.4}>
                                        <Typography sx={{fontSize:'12px', color:'#83888E'}}>Economy</Typography>
                                        <Typography sx={{color:'#4E545D', fontSize:'14px'}}>{marker.vehicle_details?.vehicle_no}</Typography>
                                    </Grid2>
                                    
                                </Grid2>
                            </Grid2>
                        )))
                        : (<div style={styles.errorBox}>
                            <p>No driver is online at this time.</p>
                        </div>)
                    }
                </Grid2>

                {!gridClickData && (
                    <Grid2 item size={7.5}>
                        <Grid2 item sx={{marginTop:'2%'}}>
                            {isLoaded ? (
                                <GoogleMap mapContainerStyle={containerStyleMain} center={centerMain} zoom={6} onLoad={onLoad} onUnmount={onUnmount}>
                                    {mapViewData && mapViewData.length > 0 && mapViewData.map((marker, index) => {
                                    // console.log('here in isNearby true = ', marker)
                                    return (
                                        <Marker
                                            key={index}
                                            position={{ lat: Number(marker.driver_details?.driver_current_latitude), lng: Number(marker.driver_details?.driver_current_longitude) }}
                                            title={marker.engagement_details?.engagement_id}
                                            icon={{
                                                url: mapPin,
                                                scaledSize: new window.google.maps.Size(30, 30)
                                            }}
                                        />
                                    );
                                })}

                                </GoogleMap>
                                
                            ): (<></>)}

                        </Grid2>
                    </Grid2>
                )}

                {gridClickData && (
                    <Grid2 item size={7.8}>
                        <Grid2 item sx={{marginTop:'2%'}}>
                            {isLoaded ? (
                                <GoogleMap mapContainerStyle={containerStyle} center={center} zoom={6} onLoad={onLoad} onUnmount={onUnmount}>
                                    {/* {pickupLatLng && (
                                        <Marker key={gridClickData.driver_details?.driver_id} position={pickupLatLng}
                                            title={'pickup'}
                                            icon={{
                                                url: pickupIcon,
                                                scaledSize: new window.google.maps.Size(30, 30)
                                            }} 
                                        />
                                    )}
                                    {dropLatLng && (
                                        <Marker key={gridClickData.engagement_details?.engagement_id} position={dropLatLng}
                                            title={'drop'}
                                            icon={{
                                                url: dropIcon,
                                                scaledSize: new window.google.maps.Size(30, 30)
                                            }} 
                                        />
                                    )} */}
                                </GoogleMap>
                            ): (<></>)}
                        </Grid2>
                    
                        <Grid2 item sx={{backgroundColor:'#fff', borderRadius:"12px"}}>
                            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                                <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
                                    <Tab label="Trip Details" {...a11yProps(0)} sx={{textTransform: 'none'}} />
                                    <Tab label="Driver Info" {...a11yProps(1)} sx={{textTransform: 'none'}} />
                                    <Tab label="Rider Info" {...a11yProps(2)} sx={{textTransform: 'none'}} />
                                    <Tab label="Vehicle Details" {...a11yProps(3)} sx={{textTransform: 'none'}} />
                                    <Tab label="Payment Details" {...a11yProps(4)} sx={{textTransform: 'none'}} />
                                </Tabs>
                            </Box>

                            <CustomTabPanel value={value} index={0}>
                                <Grid2 container sx={{paddingLeft:'16px', paddingTop:'10px'}}>
                                    <Grid2 item size={2}>
                                        <Typography sx={{color:'#83888E', fontSize:'14px'}}>Engagement ID</Typography>
                                        <Typography sx={{fontSize:'16px'}}>{gridClickData.engagement_details?.engagement_id}</Typography>
                                    </Grid2>
                                    <Grid2 item size={2}>
                                        <Typography sx={{color:'#83888E', fontSize:'14px'}}>Vehicle Type</Typography>
                                        {gridClickData.engagement_details?.vehicle_type==1 && (
                                            <Grid2><img src={vehicleTypeCar} alt="taxi"/></Grid2>
                                        )}
                                        {gridClickData.engagement_details?.vehicle_type==2 && (
                                            <Grid2><img src={vehicleTypeBike} alt="bike"/></Grid2>
                                        )}
                                        {gridClickData.engagement_details?.vehicle_type==3 && (
                                            <Grid2><img src={vehicletypeAuto} alt="auto"/></Grid2>
                                        )}
                                    </Grid2>
                                    <Grid2 item size={2}>
                                        <Typography sx={{color:'#83888E', fontSize:'14px'}}>Ride Start Date</Typography>
                                        <Typography sx={{fontSize:'14px'}}>
                                            {gridClickData.engagement_details?.pickup_time ? gridClickData.engagement_details?.pickup_time?.split('T')[0] : '--'}
                                        </Typography>
                                    </Grid2>
                                    
                                    <Grid2 item size={2.5}>
                                        <Typography sx={{color:'#83888E', fontSize:'14px'}}>Start Time</Typography>
                                        <Typography sx={{fontSize:'14px'}}>
                                            {gridClickData.engagement_details?.pickup_time ? gridClickData.engagement_details?.pickup_time?.split('T')[1] : '--'}
                                        </Typography>
                                    </Grid2>
                                    <Grid2 item size={2}>
                                        <Typography sx={{color:'#83888E', fontSize:'14px'}}>Booking Distance</Typography>
                                        <Typography sx={{fontSize:'14px'}}>
                                            {gridClickData.engagement_details?.ride_distance} km</Typography>
                                    </Grid2>
                                </Grid2>
                                <hr/>

                                <Grid2 container sx={{paddingLeft:'12px', paddingBottom:'8px'}}>
                                    <Grid2 item size={6}>
                                        <Grid2 item sx={{display:'flex'}}>
                                            <img src={pickupMarker} alt="pickup loc" height="20px" width="20px" />
                                            <Typography sx={{color:'#83888E', fontSize:'14px', marginLeft:'2%'}}>Pickup Location</Typography>
                                        </Grid2>
                                        <Grid2 item>
                                            <Typography sx={{marginLeft:'2%', fontSize:'14px', marginTop:'1%'}}>{gridClickData.engagement_details?.pickup_address}</Typography>
                                        </Grid2>
                                    </Grid2>
                                    <Grid2 item size={6}>
                                        <Grid2 item sx={{display:'flex'}}>
                                            <img src={dropMarker} alt="drop loc" height="20px" width="20px"/>
                                            <Typography sx={{color:'#83888E', fontSize:'14px', marginLeft:'2%'}}>Drop Address</Typography>
                                        </Grid2>
                                        <Grid2 item>
                                            <Typography sx={{marginLeft:'2%', fontSize:'14px', marginTop:'1%'}}>{gridClickData.engagement_details?.drop_address}</Typography>
                                        </Grid2>
                                    </Grid2>
                                </Grid2>
                            </CustomTabPanel>

                            <CustomTabPanel value={value} index={1}>
                                
                                <Grid2 container sx={{ width:'auto', minWidth:'180px', padding:'16px'}}>
                                    <Grid2>
                                        <Avatar sx={{borderColor:'#0065FF', border:1}} alt={gridClickData.driver_details?.driver_name} src={gridClickData.driver_details?.driver_image} ></Avatar>
                                    </Grid2>
                                    <Grid2 item sx={{ml:'8px',textAlign:'left'}}>
                                        <Grid2>
                                            <Typography>{gridClickData.driver_details?.driver_name}</Typography>
                                        </Grid2>
                                        <Grid2>
                                            <Typography sx={{color:'#83888E', fontSize:'14px'}}>Rating: {gridClickData.driver_details?.total_rating}</Typography>
                                        </Grid2>
                                    </Grid2>
                                </Grid2>

                                <Grid2 container spacing={2} sx={{paddingLeft:'16px', paddingBottom:'12px'}}>
                                    <Grid2 item size={1.8}>
                                        <Typography sx={{color:'#83888E', fontSize:'14px'}}>Driver ID</Typography>
                                        <Typography sx={{fontSize:'16px', wordBreak: 'break-word'}}>{gridClickData.driver_details?.driver_id}</Typography>
                                    </Grid2>
                                    <Grid2 item size={2.5}>
                                        <Typography sx={{color:'#83888E', fontSize:'14px'}}>Mobile Number</Typography>
                                        <Typography sx={{fontSize:'16px', wordBreak: 'break-word'}}>{gridClickData.driver_details?.driver_phone_number}</Typography>
                                    </Grid2>
                                    <Grid2 item size={3.2}>
                                        <Typography sx={{color:'#83888E', fontSize:'14px'}}>Email</Typography>
                                        <Typography sx={{fontSize:'16px', wordBreak: 'break-word'}}>{gridClickData.driver_details?.driver_email}</Typography>
                                    </Grid2>
                                    <Grid2 item size={2.2}>
                                        <Typography sx={{color:'#83888E', fontSize:'14px'}}>City</Typography>
                                        <Typography sx={{fontSize:'16px', wordBreak: 'break-word'}}>{gridClickData.engagement_details.city_name}</Typography>
                                    </Grid2>
                                    <Grid2 item size={2}>
                                        <Typography sx={{color:'#83888E', fontSize:'14px'}}>Trips</Typography>
                                        <Typography sx={{fontSize:'16px', wordBreak: 'break-word'}}>{gridClickData.driver_details?.total_trips}</Typography>
                                    </Grid2>
                                </Grid2>
                            </CustomTabPanel>

                            <CustomTabPanel value={value} index={2}>

                                <Grid2 container sx={{ width:'auto', minWidth:'180px', padding:'16px'}}>
                                    <Grid2>
                                        <Avatar sx={{borderColor:'#0065FF', border:1}} alt={gridClickData.user_details?.user_name} src={gridClickData.user_details?.user_image} ></Avatar>
                                    </Grid2>
                                    <Grid2 item sx={{ml:'8px',textAlign:'left'}}>
                                        <Grid2>
                                            <Typography>{gridClickData.user_details?.user_name}</Typography>
                                        </Grid2>
                                        <Grid2>
                                            <Typography sx={{color:'#83888E', fontSize:'14px'}}>Rating: {gridClickData.user_details?.total_rating}</Typography>
                                        </Grid2>
                                    </Grid2>
                                </Grid2>
                                <Grid2 container spacing={2} sx={{paddingLeft:'16px', paddingBottom:'12px'}}>
                                    <Grid2 item size={1.8}>
                                        <Typography sx={{color:'#83888E', fontSize:'14px'}}>User ID</Typography>
                                        <Typography sx={{fontSize:'16px', wordBreak: 'break-word'}}>{gridClickData.user_details?.user_id}</Typography>
                                    </Grid2>
                                    <Grid2 item size={2.5}>
                                        <Typography sx={{color:'#83888E', fontSize:'14px'}}>Mobile Number</Typography>
                                        <Typography sx={{fontSize:'16px', wordBreak: 'break-word'}}>{gridClickData.user_details?.user_phone_number}</Typography>
                                    </Grid2>
                                    <Grid2 item size={3.2}>
                                        <Typography sx={{color:'#83888E', fontSize:'14px'}}>Email</Typography>
                                        <Typography sx={{fontSize:'16px', wordBreak: 'break-word'}}>{gridClickData.user_details?.user_email}</Typography>
                                    </Grid2>
                                    <Grid2 item size={2.2}>
                                        <Typography sx={{color:'#83888E', fontSize:'14px'}}>City</Typography>
                                        <Typography sx={{fontSize:'16px', wordBreak: 'break-word'}}>{gridClickData.engagement_details.city_name}</Typography>
                                    </Grid2>
                                    <Grid2 item size={2}>
                                        <Typography sx={{color:'#83888E', fontSize:'14px'}}>Trips</Typography>
                                        <Typography sx={{fontSize:'16px', wordBreak: 'break-word'}}>{gridClickData.user_details?.total_trips}</Typography>
                                    </Grid2>
                                </Grid2>
                            </CustomTabPanel>

                            <CustomTabPanel value={value} index={3}>
                                <Grid2 item container sx={{padding:'16px'}}>
                                    <Grid2 item size={2}>
                                        {gridClickData.engagement_details?.vehicle_type==1 && (
                                            <Grid2><img src={vehicleTypeCar} alt="taxi"/></Grid2>
                                        )}
                                        {gridClickData.engagement_details?.vehicle_type==2 && (
                                            <Grid2><img src={vehicleTypeBike} alt="bike"/></Grid2>
                                        )}
                                        {gridClickData.engagement_details?.vehicle_type==3 && (
                                            <Grid2><img src={vehicletypeAuto} alt="auto"/></Grid2>
                                        )}
                                    </Grid2>
                                    <Grid2 item size={3}>
                                        <Typography sx={{color:'#83888E', fontSize:'14px'}}>Vehicle Type</Typography>
                                        <Typography sx={{fontSize:'14px'}}>
                                                            {gridClickData.vehicle_details?.vehicle_type === 1 ? 'Taxi' : gridClickData.vehicle_details?.vehicle_type === 2 ? 'Bike' : gridClickData.vehicle_details?.vehicle_type === 3 ? 'Auto' : 'Unknown'}</Typography>
                                    </Grid2>
                                    <Grid2 item size={3}>
                                        <Typography sx={{color:'#83888E', fontSize:'14px'}}>Vehicle Number</Typography>
                                        <Typography sx={{fontSize:'14px'}}>{gridClickData.vehicle_details?.vehicle_no}</Typography>
                                    </Grid2>
                                </Grid2>
                            </CustomTabPanel>

                            <CustomTabPanel value={value} index={4}>
                                <Grid2 container sx={{paddingLeft:'16px', paddingBottom:'12px', paddingTop:'16px'}}>
                                    <Grid2 item size={3}>
                                        <Typography sx={{color:'#83888E', fontSize:'14px'}}>Payment Mode</Typography>
                                        <Typography sx={{fontSize:'16px'}}>{gridClickData.payment_details?.payment_mode==1 ? 'CASH' : 'STRIPE'}</Typography>
                                    </Grid2>
                                    <Grid2 item size={3}>
                                        <Typography sx={{color:'#83888E', fontSize:'14px'}}>Fare</Typography>
                                        <Typography sx={{fontSize:'16px'}}>{gridClickData.payment_details?.trip_fare}</Typography>
                                    </Grid2>
                                    <Grid2 item size={3}>
                                        <Typography sx={{color:'#83888E', fontSize:'14px'}}>Payment Status</Typography>
                                        <Typography sx={{fontSize:'16px'}}>{gridClickData.payment_details?.payment_status == 0 ? 'Pending' : 'Success'}</Typography>
                                    </Grid2>
                                    
                                </Grid2>
                            </CustomTabPanel>
                        </Grid2>
                    </Grid2>
                )}
            </Grid2>
        </div>
    )
}

export default MapView;